export default {
	"sendGoods": {
		"printStockList": "Print the stocking list",
		"sendGoodsHandle": "Ship",
		"andSelfNo": "self pickup order number",
		"subSelfNo": "Cancel self-pickup",
		"tips": "There are duplicate labels in this dispatch order, you must select the transfer order number to ship",
		"cancelSendGoods": "cancel shipment",
		"deliverNo": "Invoice",
		"sendGoodsDialog": "delivery information",
		"tagAnomalyDialog": "Label delivery exception information",
		"andSelfDialog": "Append pickup order",
		"transferBillList": "Transfer order list",
		"deliveryName": "Shipping operator",
		"deliveryTime": "Shipping time",
		"cancelTransferBill": "Are you sure you want to cancel this transfer order?",
		"validataTips1": "Please enter the actual number of packages!",
		"validataTips2": "Please enter the number of damaged packages!",
		"validataTips3": "Cancelled delivery successfully!",
		"validataTips4": "Cancellation of shipment failed!",
		"validataTips5": "Please select the same transfer order number to re-label!"
	},
	"transferDelivery": {
		"sendGoods": "Ship",
		"sendGoodsCompleteTime": "Pickup completion time",
		"sendGoodsComplete": "Shipment completed",
		"downloadDeliverNo": "print invoice",
		"deliveredContainerQty": "Number of container labels",
		"transferNums": "orders",
		"deliveredPackingQty": "Number of packaging labels",
		"transferBillInfo": "Transfer order information",
		"losePackingDialogTitile": "Missing packaging information",
		"startDeliveryDt": "start shipping time",
		"dispatchingDt": "Schedule time",
		"fileNum": "attached sheet",
		"Tips1": "Unscanned packages are as follows",
		"Tips2": "Please confirm if the package in the list is missing?",
		"identification": "driver ID number"
	},
	"transferList": {
		"appointmentHandle": "To have an appointment",
		"expectedReceiveTime": "Plan the goods time",
		"actualReceiveTime": "Actual shipping time",
		"expectedDeliveryTime": "Plan the delivery time",
		"actualDeliveryTime": "The actual delivery time",
		"affixedCodeType": "And pasted code",
		"receiveRouteNo": "The goods send a single number",
		"receiveTransportNo": "Receive waybill number",
		"deliveryTransportNo": "Send waybill number",
		"deliveryRouteNo": "The delivery send a single number",
		"planDeliveryDt": "Booking the delivery time",
		"planReceiveDt": "Make an appointment to receiving time",
		"receiveDispatcherName": "People receiving dispatching",
		"receiveComplete": "The goods finish",
		"packingContainer": "Printing container labels",
		"collectGoods": "The goods",
		"filesManageShowHide": "The attached list in the attachment",
		"acPacking": "Paid-in/receivable packing number",
		"receivedGoodsTemperature": "Temperature ℃ for receiving goods",
		"patchLabel": "For labeling",
		"labelNo": "Tag number",
		"labelType": "The tag type",
		"printPackingTag": "Printing packing label",
		"storePlace": "location",
		"tagNumber": "Tag number",
		"storeReceivePlace": "The goods location",
		"containNum": "The container number of the inner packing",
		"number": "The container number",
		"source": "The label source",
		"scaned": "scanned",
		"goodsInfoDialog": "The consignee or consignor information",
		"tag": "The label",
		"damagedPackingQty": "Damage to the package number",
		"tips1": "The label for the receiving status to modify the information",
		"tips2": "The label has been receiving, can modify information after clicking the \"submit\"",
		"tagTitle": "Label the goods exception information",
		"reason": "why",
		"copyAll": "Copy all the information",
		"appointmentTitle": "To the information",
		"mapTracking": "GPS Mobile Tracking",
		"distance": "Now the distance",
		"deliveryBillTypeStr": "Invoice type",
		"tempControlName": "Temperature type",
		"validataTips1": "Please enter the location!",
		"validataTips2": "Please select a label source!",
		"validataTips3": "Please enter a tag number!",
		"receiveSuccess": "Receiving success!",
		"validataTips4": "Please enter a container number!",
		"validataTips5": "Please enter a container number of the inner packing!",
		"validataTips6": "Please enter a tag number!",
		"validataTips7": "Must check the data are already receiving state!",
		"validataTips8": "Sure you want to receive operation",
		"validataTips9": "Heavy success!",
		"validataTips10": "Heavy accept failure!",
		"validataTips11": "Check the data cannot be 'has the delivery status!",
		"validataTips12": "Sure you want to become invalid operation",
		"validataTips13": "Receiving goods wen please enter a number - between 100 and 100",
		"validataTips14": "Please select not forwarding invoice generated transfer list!",
		"validataTips15": "Please select a transit single status to 'stay the goods' or' has been receiving the transfer list",
		"validataTips16": "All transit single site must be the same!",
		"validataTips17": "All transfer list must be the same the owner!",
		"validataTips18": "Please select a plan to delivery time interval!",
		"validataTips19": "Since the mention booking success!"
	}
}


// WEBPACK FOOTER //
// ./src/lang/en/pages/transfer/transfer.js